(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReportReservationsByGroup',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.btn-radio').click(function toggleFormFields() {
			if ($(this).data("val") === 'group_number') {
				$('.group-number-container').removeClass('hidden');
				$('.sailing-selection-container').addClass('hidden');

				$('#reportreservationsbygroup-cruise_line').val('');
				$('#reportreservationsbygroup-ships').val('');
				$('#reportreservationsbygroup-itinerary_id').val('');
			} else {
				$('.sailing-selection-container').removeClass('hidden');
				$('.group-number-container').addClass('hidden');

				$('#reportreservationsbygroup-group_number').val('');
			}
		});
	};

}(jQuery, window.Adzuki || {}));